enum AssetCounterIndexFieldNames {
  Action = 'action',
  Index = 'index',
  CounterView = 'counter-view',
}

export default AssetCounterIndexFieldNames;
